import { Grid, Stack } from '@mui/material';
import EventFormCollapse from 'app/event/eventForm/common/EventFormCollapse';
import EventItemCarousel from 'app/event/eventForm/common/EventItemCarousel';

import CalendarType from 'common/enums/calendarTypes';
import SearchInput from 'common/features/filters/components/SearchInput';
import useFlexBoxStyles from 'common/flexBox';
import { useEffect, useState } from 'react';
import ServiceFormCalendarItem from './ServiceFormCalendarItem';

const ServiceCalendarsRender = (props) => {
    const {
        sectionTitle,
        hideAdd,
        calendars: allCalendars = [],
        editButton,
        editCalendar,
        selectCalendar,
        addButtonText,
        deleteCalendar,
        activeCalendar,
        expanded,
        deleteButton = true,
        carousel = true,
    } = props;

    const { classes: flexBox } = useFlexBoxStyles();
    const [calendars, setCalendars] = useState(allCalendars);

    useEffect(() => {
        setCalendars(allCalendars);
    }, [allCalendars]);

    const onSearchChange = async (value) => {
        setCalendars(
            allCalendars.filter((calendar) =>
                (
                    calendar.name +
                    (calendar.type === CalendarType.AGENT ? calendar.email : calendar?.extraFields?.resourceId ?? '')
                )
                    .toLowerCase()
                    .includes(value.toLowerCase()),
            ),
        );
    };

    const items = (
        <Grid container spacing={1} wrap={carousel ? 'nowrap' : 'wrap'}>
            {calendars.map((calendar, idx) => {
                return (
                    <Grid key={idx} item md={4} sm={12}>
                        <ServiceFormCalendarItem
                            enableOnClick={false}
                            calendar={calendar}
                            activeCalendar={activeCalendar}
                            deleteCalendar={deleteCalendar}
                            deleteButton={deleteButton}
                            editCalendar={editCalendar}
                            editButton={editButton}
                        />
                    </Grid>
                );
            })}
        </Grid>
    );

    const searchControl = (
        <SearchInput
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            size="small"
            onChange={onSearchChange}
        />
    );

    return (
        <Stack direction="column" className={flexBox.marginTop1}>
            <EventFormCollapse
                hideAdd={hideAdd}
                hideExpand={!calendars?.length}
                expanded={expanded}
                sectionTitle={sectionTitle}
                selectAsset={selectCalendar}
                addButtonText={addButtonText}
                canExpand={calendars.length > 0}
                searchControl={searchControl}
            >
                {carousel ? <EventItemCarousel upcomingLength={calendars?.length}>{items}</EventItemCarousel> : items}
            </EventFormCollapse>
        </Stack>
    );
};

export default ServiceCalendarsRender;
